// extracted by mini-css-extract-plugin
export var close = "Titlebar-module--close--5c943";
export var icon = "Titlebar-module--icon--a68cd";
export var items = "Titlebar-module--items--132ea";
export var maximize = "Titlebar-module--maximize--a480e";
export var minimize = "Titlebar-module--minimize--cfbad";
export var title = "Titlebar-module--title--2dd86";
export var titlebar = "Titlebar-module--titlebar--4a4dd";
export var windowButtons = "Titlebar-module--windowButtons--0b872";